import React from 'react';

// Utilities
import extendClassNameWithModifier from '../../../../../lib/bemUtils/bem';

export const FormsElementContainerModifier = {
  BUTTON_GROUP_RIGHT: 'form-element-container--button-group-right',
  BUTTON_GROUP_RIGHT_NO_CENTER: 'form-element-container--button-group-right-no-center',
};

type FormsElementContainerProps = {
  modifier?: string | string[];
  children: React.ReactNode;
};

/** The container for form elements. Best semantic is <p> here. */
export default function FormsElementContainer({ modifier, children }: FormsElementContainerProps) {
  return <p className={extendClassNameWithModifier('form-element-container', modifier)}>{children}</p>;
}
